import React, { FC } from 'react';
import { FormSection } from 'omni-package-react-core';
import PasswordRow from '../../../../components/_PasswordRow';
import UsernameControl from './UsernameControl';

export interface UsernameSectionProps { }

const UsernameSection: FC<UsernameSectionProps> = () => (
  <FormSection>
    <UsernameControl />
    <PasswordRow />
  </FormSection>
);

export default UsernameSection;
